(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/bet-proposal/assets/javascripts/excluded-products.js') >= 0) return;  svs.modules.push('/components/marketplace/bet-proposal/assets/javascripts/excluded-products.js');
'use strict';

setGlobal('svs.components.marketplace.betProposal.excludedProducts', {
  maltipset: true
});

 })(window);